import { render, staticRenderFns } from "./loginRole.vue?vue&type=template&id=8af3c490&scoped=true&"
import script from "./loginRole.vue?vue&type=script&lang=js&"
export * from "./loginRole.vue?vue&type=script&lang=js&"
import style0 from "./loginRole.vue?vue&type=style&index=0&id=8af3c490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af3c490",
  null
  
)

export default component.exports